module.exports = __webpack_public_path__ + "img/offers-empty-state-no-results.b38a1de9.svg";